var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c("div", { staticClass: "dialog" }, [
        _c("div", { staticClass: "dialog-box" }, [
          _c("div", { staticClass: "dialog-head" }, [
            _vm._v(_vm._s(_vm.title))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dialog-body" }, [
            _vm._v(_vm._s(_vm.message))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dialog-foot" }, [
            _c(
              "a",
              {
                staticClass: "primary",
                attrs: { href: "javascript:;" },
                on: {
                  click: function($event) {
                    _vm.dialogClick("submit")
                  }
                }
              },
              [_vm._v("确认")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "default",
                attrs: { href: "javascript:;" },
                on: {
                  click: function($event) {
                    _vm.dialogClick("cancel")
                  }
                }
              },
              [_vm._v("取消")]
            )
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }